import posthog from 'posthog-js';

const posthogKey = import.meta.env.VITE_POSTHOG_API_KEY;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';
const isProduction = import.meta.env.PROD;
const enabledInDev = import.meta.env.VITE_POSTHOG_ENABLED_IN_DEV === 'true' || false;

if (posthogKey && (isProduction || enabledInDev)) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    capture_exceptions: {
      // Only capture actual JS crashes — unhandled rejections and console errors
      // are handled manually in main.tsx with proper filtering to avoid false positives
      // from managed API errors (Axios timeouts, 401s, TanStack Query retries, etc.)
      capture_unhandled_errors: true,
      capture_unhandled_rejections: false,
      capture_console_errors: false,
    },
    enable_recording_console_log: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-posthog-mask]',
      blockClass: 'ph-no-capture',
      blockSelector: '[data-posthog-block]',
      ignoreClass: 'ph-ignore',
      maskCapturedNetworkRequestFn: (request) => {
        if (request.name?.includes('password') || request.name?.includes('token')) {
          return null;
        }
        return request;
      },
    },
    autocapture: {
      dom_event_allowlist: ['click', 'submit', 'change'],
      element_allowlist: ['button', 'a'],
      css_selector_allowlist: ['[data-track]'],
    },
    respect_dnt: true,
    loaded: (ph) => {
      if (!isProduction) {
        ph.debug();
      }
    },
  });
}

export default posthog;
